import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, MatProgressSpinner, AsyncPipe],
})
export class SpinnerComponent {
  @Input() isLoadingResults$: Observable<boolean> = new Observable<boolean>();
  @Input() loaderMessage$: Observable<string> = new Observable<string>();
}
